import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { AuthContext } from '../context/AuthContext';

const Navbar = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">AngioInsight</div>
        <ul className="navbar-menu">
          <li>
            <Link to="/patients">Patients</Link>
          </li>
          <li>
            <Link to="/studies">Studies</Link>
          </li>
          <li>
            <Link to="/dicoms">XA DICOMs</Link>
          </li>
          <li>
            <Link to="/fsa_labels">FSA Labels</Link>
          </li>
          <li>
            <Link to="/segm_anno_labels">SegmAnno Labels</Link>
          </li>
        </ul>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
